import React, { useEffect, useRef } from "react";
import styles from "./RecoveryProgressPopup.module.scss";
import clsx from "clsx";
import { useProjectsStore } from "../../store";
import { almiWhite } from "../../../assets/images";

const RecoveryProgressPopup: React.FC = () => {
  const {
    currentJob,
    clearRecovery,
    recoveryPopupMinimized,
    setRecoveryPopupMinimized,
    selectLoading,
  } = useProjectsStore();

  const logsEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    logsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [currentJob?.logs]);
  const progressValue = currentJob?.progress?.progress ?? 0;

  useEffect(() => {
    console.log(
      "[POPUP] re-render → progress =",
      progressValue,
      "logs =",
      currentJob?.logs?.length,
    );
  }, [progressValue, currentJob?.logs]);
  if (!currentJob && !selectLoading) return null;

  const isFinished = currentJob?.isFinished ?? false;
  const isSuccess = currentJob?.isSuccess ?? false;

  const titleText = isFinished
    ? isSuccess
      ? "Восстановление успешно завершено!"
      : "Произошла ошибка"
    : currentJob?.progress?.message || "Выполняем восстановление...";

  const getLogClass = (log: string) => {
    console.log(log);
    return "";
  };

  if (!recoveryPopupMinimized) {
    return (
      <div className={styles.overlay}>
        <div className={styles.popup}>
          <div
            className={styles.headerCircle}
            onClick={() => setRecoveryPopupMinimized(true)}
            title="Свернуть"
            role="button"
            tabIndex={0}
          >
            <img
              className={styles.almiGif}
              src={almiWhite}
              width={110}
              height={110}
            />
          </div>

          <h2 className={styles.title}>{titleText}</h2>

          <div className={styles.progressContainer}>
            <div className={styles.progressBarWrapper}>
              <div
                className={styles.progressBar}
                style={{ width: `${progressValue}%` }}
              />
              <span className={styles.progressText}>
                {Math.round(progressValue)}%
              </span>
            </div>
          </div>

          <div className={styles.logsContainer}>
            {currentJob && currentJob?.logs?.length > 0 ? (
              currentJob?.logs.map((log, index) => (
                <div
                  key={index}
                  className={clsx(styles.logLine, getLogClass(log))}
                >
                  {log}
                </div>
              ))
            ) : (
              <div className={styles.logLine}>Подключаемся к бэкенду...</div>
            )}
            <div ref={logsEndRef} />
          </div>

          {isFinished && (
            <button
              className={styles.closeButton}
              onClick={() => {
                clearRecovery();
                setRecoveryPopupMinimized(false);
              }}
            >
              Закрыть
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={styles.floatingIcon}
      onClick={() => setRecoveryPopupMinimized(false)}
      title="Открыть прогресс восстановления"
    >
      <div className={styles.floatingArc}>
        <img
          className={styles.miniAlmi}
          src={almiWhite}
          width={62}
          height={62}
        />
      </div>

      <div className={styles.progressBadge}>{Math.round(progressValue)}%</div>

      <button
        className={styles.floatingClose}
        onClick={(e) => {
          e.stopPropagation();
          clearRecovery();
          setRecoveryPopupMinimized(false);
        }}
        title="Закрыть полностью"
      >
        ✕
      </button>
    </div>
  );
};

export default RecoveryProgressPopup;
